import { KEY_SAVE_INIT_VALUE_FORM, NAME_FORMS } from 'const';
import { IUserInfo } from 'redux/reducers/user/type';
import { IApplication } from 'redux/reducers/userApplications/type';

export const getStorageSaveInitValueFrom = <T>(nameForm: NAME_FORMS): T => {
  const valuesForms = JSON.parse(localStorage.getItem(KEY_SAVE_INIT_VALUE_FORM) || '{}');

  return valuesForms[nameForm] || {};
};

export const setStorageSaveInitValueFrom = (nameForm: NAME_FORMS, values: Partial<IUserInfo>) => {
  const valuesForms = JSON.parse(localStorage.getItem(KEY_SAVE_INIT_VALUE_FORM) || '{}');

  localStorage.setItem(
    KEY_SAVE_INIT_VALUE_FORM,
    JSON.stringify({
      ...valuesForms,
      [nameForm]: {
        ...valuesForms[nameForm],
        ...values,
      },
    })
  );

  return true;
};

export const setStorageSaveInitValueFromCalc = (
  nameForm: NAME_FORMS,
  values: Partial<IApplication>
) => {
  const valuesForms = JSON.parse(localStorage.getItem(KEY_SAVE_INIT_VALUE_FORM) || '{}');

  localStorage.setItem(
    KEY_SAVE_INIT_VALUE_FORM,
    JSON.stringify({
      ...valuesForms,
      [nameForm]: {
        ...valuesForms[nameForm],
        ...values,
      },
    })
  );

  return true;
};
export const setStorageSaveRegistrationFromCalc = (
  nameForm: NAME_FORMS,
  values: Partial<IApplication>
) => {
  const valuesForms = JSON.parse(localStorage.getItem(KEY_SAVE_INIT_VALUE_FORM) || '{}');

  localStorage.setItem(
    KEY_SAVE_INIT_VALUE_FORM,
    JSON.stringify({
      ...valuesForms,
      [nameForm]: {
        ...valuesForms[nameForm],
        ...values,
      },
    })
  );

  return true;
};
